import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getDocs, collection, query, where } from 'firebase/firestore';
import { db } from '../../../../firebase';
import { Spin } from 'antd';
import BreadCrumb from '../../common/breadcrumb/breadCrumb';
import { all_routes } from '../../../../core/data/routes/all_routes';

const TechCategories = () => {
  const location = useLocation();
  const [service, setService] = useState(location.state?.service || null);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const navigate = useNavigate();
  const routes = all_routes;

  useEffect(() => {
    if (!service) {
      console.warn("No service found in state. Ensure you're passing it correctly.");
    }
  }, [service]);

  // Fetch categories that match the service type
  const fetchCategories = async () => {
    if (!service || !service.type) return; // Ensure service and type exist

    setLoading(true);
    try {
      const q = query(
        collection(db, 'categories'),
        where('main_type', '==', service.type) // ✅ Filtering by main_type
      );
      const categoriesSnapshot = await getDocs(q);
      const categoriesList = categoriesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCategories(categoriesList);
    } catch (error) {
      console.error('Error fetching categories:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (service) {
      fetchCategories();
    }
  }, [service]); // Run only when service is available

  const handleItemClick = (index) => {
    setSelectedItems((prevSelectedItems) => {
      const updatedSelectedItems = [...prevSelectedItems];
      updatedSelectedItems[index] = !updatedSelectedItems[index];
      return updatedSelectedItems;
    });
  };

  // Navigate to Categories Details Page with Category Data
  const handleBookNow = (category) => {
    console.log("testing_click")
    navigate(routes.serviceDetails1, { state: { category } });
  };


  return (
    <>
      <BreadCrumb title="Categories" item1="Categories" />

      <div className="page-wrapper">
        <div className="content"
        style={{
          backgroundImage: `url("https://i.postimg.cc/mZ5fxsvz/bg.jpg")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}>
          <div className="container">
            <div className="row">
              <div className="col-xl-2 col-lg-4 theiaStickySidebar"></div>
              <div className="col-xl-9 col-lg-8">
                <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
                  <h4 style={{color: "white"}}>Found <span className="text-primary">{categories.length} Categories</span></h4>
                </div>

                {/* Categories Data */}
                <div className="row">
                  {loading ? (
                    <Spin className="col-xl-3 col-lg-4 theiaStickySidebar" />
                  ) : (
                    categories.length > 0 ? (
                      categories.map((category, index) => (
                        <div className="col-xl-4 col-md-6" key={category.id}>
                          <div className="card p-0"
                          style={{
                            background: "rgba(255, 255, 255, 0.1)",
                            borderRadius: "15px",
                            backdropFilter: "blur(10px)",
                            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                            borderColor: "#ffffff00",
                            color: "#fff",
                          }}>
                            <div className="card-body p-0">
                              <div className="img-sec w-100">
                                <Link to="#">
                                  <img
                                    src={category.category_view_icon || "placeholder-image-path.jpg"}
                                    className="img-fluid rounded-top w-100"
                                    alt="category"
                                  />
                                </Link>
                                <div className="image-tag d-flex justify-content-end align-items-center">
                                  <span className="trend-tag">
                                    {category.main_type || "Untitled Category"}
                                  </span>
                                  <Link
                                    to="#"
                                    onClick={() => handleItemClick(index)}
                                    className={`fav-icon like-icon ${selectedItems[index] ? 'selected' : ''}`}
                                  >
                                    <i className="ti ti-heart" />
                                  </Link>
                                </div>
                                <span className="image-logo avatar avatar-md border rounded-circle">
                                  <img
                                    src={category.icon || "placeholder-image-path.jpg"}
                                    className="img-fluid rounded-circle"
                                    alt="logo"
                                  />
                                </span>
                              </div>
                              <div className="p-3">
                                <h5 className="mb-2" style={{color: "white"}}>{category.title || "Untitled Category"}</h5>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <span className="rating fs-14" style={{color: "white"}}>
                                    <i className="fa fa-star filled me-1"  style={{color: "gold"}}/> 4.9
                                  </span>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                  <h5 style={{color: "white"}}>₹ {category.price ? category.price.toFixed(2) : "Price not available"}</h5>
                                  <div
                                    // to="#" 
                                    onClick={() => handleBookNow(category)}
                                    className="btn bg-primary-transparent">Book Now</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>No categories found for this service type.</p>
                    )
                  )}
                </div>

                {/* Pagination */}
                <nav aria-label="Page navigation">
                  <ul className="paginations d-flex justify-content-center align-items-center">
                    <li className="page-item me-3">
                      <Link to="#" className="page-link" style={{color: "white"}}>
                        <i className="ti ti-arrow-left me-2" /> Prev
                      </Link>
                    </li>
                    <li className="page-item me-2">
                      <Link className="page-link-1 active d-flex justify-content-center align-items-center " to="#">1</Link>
                    </li>
                    <li className="page-item me-2">
                      <Link className="page-link-1 d-flex justify-content-center align-items-center " to="#">2</Link>
                    </li>
                    <li className="page-item me-3">
                      <Link className="page-link-1 d-flex justify-content-center align-items-center " to="#">3</Link>
                    </li>
                    <li className="page-item">
                      <Link className="page-link" to="#" style={{color: "white"}}>Next <i className="ti ti-arrow-right ms-2" /></Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TechCategories;
